import { Children, isValidElement, type ReactNode } from 'react';
import { View, type ViewStyle } from 'react-native';
import { motion } from '../../theme/motion';
import { FadeIn } from './FadeIn';

interface StaggeredListProps {
  children: ReactNode;
  staggerDelay?: number;
  initialDelay?: number;
  style?: ViewStyle;
  itemStyle?: ViewStyle;
}

/**
 * Cards and rows enter in sequence, top to bottom, on the same recipe a screen
 * uses to arrive: a short rise on the entrance ease, one step apart.
 */
export function StaggeredList({
  children,
  staggerDelay = motion.stagger.step,
  initialDelay = 0,
  style,
  itemStyle,
}: Readonly<StaggeredListProps>) {
  const childArray = Children.toArray(children);

  return (
    <View style={style}>
      {childArray.map((child, index) => {
        const childKey = isValidElement(child)
          ? (child.key ?? `stagger-${index}`)
          : `stagger-${index}`;
        return (
          <FadeIn
            key={childKey}
            delay={initialDelay + index * staggerDelay}
            duration={motion.durations.normal}
            translateY={10}
            style={itemStyle}
          >
            {child}
          </FadeIn>
        );
      })}
    </View>
  );
}
